export function isAudaxEnabled(layout, featureFlagEnabled) {
  return layout === 'x_ray_cephalometric' && featureFlagEnabled
}
